<template>
  <component :is="tag"
             class="row"
             :class="[alignment, alignContents, justifyContents, {'gx-0': noGutters, 'gx-16': dense}]"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VRow',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    align: String,
    alignSm: String,
    alignMd: String,
    alignLg: String,
    alignXl: String,
    alignXxl: String,
    alignContent: String,
    alignContentSm: String,
    alignContentMd: String,
    alignContentLg: String,
    alignContentXl: String,
    alignContentXxl: String,
    justify: String,
    justifySm: String,
    justifyMd: String,
    justifyLg: String,
    justifyXl: String,
    justifyXxl: String,
    noGutters: Boolean,
    dense: Boolean,
  },
  computed: {
    alignment() {
      let classes = '';

      classes += this.align ? `align-items-${this.align} ` : '';
      classes += this.alignSm ? `align-items-sm-${this.alignSm} ` : '';
      classes += this.alignMd ? `align-items-md-${this.alignMd} ` : '';
      classes += this.alignLg ? `align-items-lg-${this.alignLg} ` : '';
      classes += this.alignXl ? `align-items-xl-${this.alignXl} ` : '';
      classes += this.alignXxl ? `align-items-xxl-${this.alignXxl} ` : '';

      return classes;
    },
    alignContents() {
      let classes = '';

      classes += this.alignContent ? `align-content-${this.alignContent} ` : '';
      classes += this.alignContentSm ? `align-content-sm-${this.alignContentSm} ` : '';
      classes += this.alignContentMd ? `align-content-md-${this.alignContentMd} ` : '';
      classes += this.alignContentLg ? `align-content-lg-${this.alignContentLg} ` : '';
      classes += this.alignContentXl ? `align-content-xl-${this.alignContentXl} ` : '';
      classes += this.alignContentXxl ? `align-content-xxl-${this.alignContentXxl} ` : '';

      return classes;
    },
    justifyContents() {
      let classes = '';

      classes += this.justify ? `justify-content-${this.justify} ` : '';
      classes += this.justifySm ? `justify-content-sm-${this.justifySm} ` : '';
      classes += this.justifyMd ? `justify-content-md-${this.justifyMd} ` : '';
      classes += this.justifyLg ? `justify-content-lg-${this.justifyLg} ` : '';
      classes += this.justifyXl ? `justify-content-xl-${this.justifyXl} ` : '';
      classes += this.justifyXxl ? `justify-content-xxl-${this.justifyXxl} ` : '';

      return classes;
    },
  }
};
</script>
